import styled, { css } from 'styled-components'
import mediaQueries from '../../../styles/mediaQueries'

export const RequestsUnreadCountWrapper = styled.span`
  position: absolute;
  right: -10px;
  top: -12px;

  ${({ inDropdown }) =>
    inDropdown &&
    css`
      top: -6px;
      right: -16px;
    `};
`

export const ButtonInnerContent = styled.span`
  position: relative;
`

export const DesktopMenu = styled.div`
  ${mediaQueries.mobile`
    display: none;
  `}
`

export const MobileMenu = styled.div`
  display: none;
  width: 100%;
  justify-content: space-between;
  margin-left: 10px;
  margin-right: -10px /* to compensate for the 10px padding in header */;

  ${mediaQueries.mobile`
    display: flex;
  `};
`
